import { ActionTree } from "vuex";
import { WidgetState } from "../models/store-state";

export default <ActionTree<WidgetState, WidgetState>>{
    navigate(context, payload) {
        let validIndex = context.getters.validIndex(payload.index)

        context.commit('setCurrentIndex', validIndex)
        context.commit('setTransition', payload.transition)
        context.commit('toggleContent', false)
    },

    swipe(context, payload) {
        if (context.getters.showNavigation) {
            if (payload.direction === 'left') {
                context.dispatch('navigate', {
                    index: context.state.currentIndex + 1,
                    transition: 'vuw-slide-right'
                })
            } 
            if (payload.direction === 'right') {
                context.dispatch('navigate', {
                    index: context.state.currentIndex - 1,
                    transition: 'vuw-slide-left'
                })
            }
        }
    }
}